<template>
  <DropdownMenuRoot>
    <slot />
  </DropdownMenuRoot>
</template>

<script setup>
import { DropdownMenuRoot } from 'radix-vue'
</script>